import { FC } from "react";
import { ButtonGroupProps } from "./types";
import { styles } from "./styles";
import { css } from "@emotion/react";

const ButtonGroup: FC<ButtonGroupProps> = ({
  children,
  fill,
  gap = "16",
  justifyContent = "center"
}) => {
  return (
    <div
      css={[
        styles.wrapper,
        fill && styles.fill,
        css`
          gap: var(--spacing-${gap});
          justify-content: ${justifyContent};
        `
      ]}
      data-testid="kit-ButtonGroup"
    >
      {children}
    </div>
  );
};

export default ButtonGroup;
export * from "./types";
